import { useQuery } from '@tanstack/react-query';
import { apiJson } from '@lib/apiClient';
import type { SidecarRecord } from '@/types/intake';

export interface ArchiveListResponse {
  items: SidecarRecord[];
}

/** Poll the archive: records that were approved and sent to print, newest dispatch first. */
export function useArchiveQueue(campaign: string) {
  return useQuery({
    queryKey: ['intake-archive', campaign],
    queryFn: () =>
      apiJson<ArchiveListResponse>(`/api/intake/archive/list?campaign=${encodeURIComponent(campaign)}`),
    refetchInterval: 60_000,
    refetchOnMount: 'always', // entering Archive pulls the current history immediately
  });
}
